export class ExtractZipErrorEffect {
  public static readonly type = '[Project/Storage/List] ExtractZipErrorEffect';
  constructor(public readonly error: Error) {}
}
